export default "__VITE_ASSET__EnFjmi$t__"